import { render, staticRenderFns } from "./sourcingmasterTS.vue?vue&type=template&id=3e45a51d&scoped=true"
import script from "./sourcingmasterTS.vue?vue&type=script&lang=js"
export * from "./sourcingmasterTS.vue?vue&type=script&lang=js"
import style0 from "./sourcingmasterTS.vue?vue&type=style&index=0&id=3e45a51d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45a51d",
  null
  
)

export default component.exports